import { render } from "./PerPageSelector.vue?vue&type=template&id=1c7b2844&ts=true"
import script from "./PerPageSelector.vue?vue&type=script&lang=ts"
export * from "./PerPageSelector.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src87568447/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__